"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PostnatalServiceInclusions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tiers = [{
    label: "ACCOMPAGNEMENT",
    scale: "Sur mesure",
    description: "Un soutien émotionnel et pratique à domicile pour vous accompagner dans vos premiers pas de maman, avec douceur et bienveillance.",
    href: "/AccommodationsPage"
  }, {
    label: "BATCH COOKING",
    scale: "Nutrition saine",
    description: "Des repas nutritifs et réconfortants préparés chez vous, pensés pour favoriser votre récupération et votre vitalité postnatale.",
    href: "/BatchCookingPage"
  }];
  return;
}